import React, { useState } from 'react';
import { getLandmarkUrl } from '../lib/landmarkImages';

/**
 * Drop-in <img> replacement that hides legacy WordPress paths (they 404) and
 * falls back to a Paisley landmark photograph (rotated deterministically by
 * `seed`) so nothing on the page ever looks "broken" — and readers still see
 * something meaningful and on-brand.
 *
 * Pass a stable `seed` (post slug, event id, etc.) so the same card always
 * shows the same landmark across renders.
 */
const PostImage = ({ src, alt, seed = '', className = '', loading = 'lazy', ...rest }) => {
  // Pre-filter known-bad legacy paths so we don't even attempt them.
  const looksBroken = !src
    || src.includes('/wp-content/uploads/')
    || src.includes('/api/uploads/wp-content/');

  const landmarkUrl = getLandmarkUrl(seed || alt || 'paisley');
  const initial = looksBroken ? landmarkUrl : src;
  const [current, setCurrent] = useState(initial);

  return (
    <img
      src={current}
      alt={alt || ''}
      loading={loading}
      onError={() => current !== landmarkUrl && setCurrent(landmarkUrl)}
      className={className}
      {...rest}
    />
  );
};

export default PostImage;
